import styled from 'styled-components';

export const DateOfBirthContainer = styled.div`
  max-width: 155px;
`;
